import React, { Component } from 'react';
import { Card, Grid, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { withRouter } from 'react-router-dom';
import { login } from '../../services/sessions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setUserData } from '../../redux/actions/user';
import JWTHelperService from '../../utils/jwtHelper';
import history from '../../utils/history';
import { withToastManager } from 'react-toast-notifications';

const styles = (theme) => ({
	wrapper: {
		position: 'relative',
	},
});

class SignIn extends Component {
	state = {
		email: '',
		password: '',
	};

	componentDidMount() {
		if (JWTHelperService.isLoggedIn()) {
			this.props.history.push({
				pathname: '/dashboard',
			});
		}
	}

	handleChange = (event) => {
		event.persist();
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	handleFormSubmit = (event) => {
		const { toastManager } = this.props;
		login({ ...this.state })
			.then((res) => {
				if (res.data.success) {
					JWTHelperService.setToken(res.data.data.token);
					localStorage.setItem('auth_user', JSON.stringify(res.data.data.user));
					this.props.setUserData(res.data.data.user);
					history.push({
						pathname: '/dashboard',
					});
				}
			})
			.catch((error) => {
				console.log(error);
				toastManager.add(error.response && error.response.data && error.response.data.message, {
					appearance: 'error',
					autoDismiss: true,
				});
			});
	};
	render() {
		let { email, password } = this.state;
		let { classes } = this.props;
		return (
			<div className="signup flex justify-center w-full h-full-screen">
				<div className="p-8">
					<Card className="signup-card position-relative y-center">
						<Grid container>
							<Grid item lg={5} md={5} sm={5} xs={12}>
								<div className="p-8 flex justify-center items-center h-full">
									<img src="/assets/images/eazydiner_1.jpg" alt="" />
								</div>
							</Grid>
							<Grid item lg={7} md={7} sm={7} xs={12}>
								<div className="p-9 h-full bg-light-gray position-relative">
									<ValidatorForm ref="form" onSubmit={this.handleFormSubmit}>
										<TextValidator
											className="mb-6 w-full"
											variant="outlined"
											label="Email"
											onChange={this.handleChange}
											type="email"
											name="email"
											value={email}
											validators={['required', 'isEmail']}
											errorMessages={['*Field required', '*Email is not valid']}
										/>
										<TextValidator
											className="mb-3 w-full"
											label="Password"
											variant="outlined"
											onChange={this.handleChange}
											name="password"
											type="password"
											value={password}
											validators={['required']}
											errorMessages={['*Field required']}
										/>
										<div className="flex flex-wrap items-center mb-4">
											<div className={classes.wrapper}>
												<Button variant="contained" color="primary" type="submit">
													Sign in
												</Button>
											</div>
										</div>
										<Button
											className="text-primary"
											onClick={() => this.props.history.push('/session/forgot-password')}
										>
											Forgot password?
										</Button>
									</ValidatorForm>
								</div>
							</Grid>
						</Grid>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	setUserData: PropTypes.func.isRequired,
});

export default withStyles(styles, { withTheme: true })(
	withRouter(connect(mapStateToProps, { setUserData })(withToastManager(SignIn)))
);
